import React, { useEffect, useMemo, useRef, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Drilldown from "highcharts/modules/drilldown";
import useApi from "./useApi";
import Loader from "src/components/loader.component";
import { Alert } from "react-bootstrap";
import NoData from "../shared/noDataComponent";
const stateKeys = {
  chart: "chart",
};
if (typeof Highcharts === "object") {
  Drilldown(Highcharts);
}
function LineChart({
  fetchOptions,
  fetchMethod,
  chartOptions,
  shouldFetch,
  chartProperties,
  events,
  seriesData,
  otherOptions,
  hasFetchParams,
  fetchParams,
  seriesKey = "series",
  loader = false,
  shouldClear
}) {
  const { awaitingResponse, data, error, handleApi } = useApi();
  const [options, setOptions] = useState(null)
  const { chart: chartState } = useMemo(() => {
    return stateKeys;
  }, []);
  const chartRef = useRef(null);
  useEffect(() => {
    shouldFetch && fetchParams && handleApi(fetchMethod, fetchOptions, stateKeys["chart"], hasFetchParams, fetchParams, shouldClear);
  }, [shouldFetch, hasFetchParams, fetchParams, shouldClear]);
  const drilldownEvents = (e) => {
    const { point, target, seriesOptions } = e;
    if (!seriesOptions) {
      const dataToDrill = shouldFetch ? data[chartState] : seriesData;
      for (let key in dataToDrill) {
        if (
          dataToDrill[key] &&
          key.includes("drilldown") &&
          dataToDrill[key].hasOwnProperty(point.drilldown)
        ) {
          const seriesToDrill = dataToDrill[key][point.drilldown];
          if (
            seriesToDrill["name"] === point.series.name &&
            [undefined, null, "line", ""].includes(seriesToDrill.type)
          ) {
            target.addSeriesAsDrilldown(point, seriesToDrill);
          }
        }
      }
      target.applyDrilldown();
    }
  };

  const propertiesForChart = useMemo(() => {
    const chartPropsToSet = chartProperties
      ? {
        ...chartProperties,
        className: "bg-gray",
      }
      : {};

    Object.defineProperties(chartPropsToSet, {
      events: {
        value: {
          ...events,
          drilldown: drilldownEvents,
        },
        writable: false,
        configurable: false,
        enumerable: true,
      },
      type: {
        value: "line",
        writable: false,
        configurable: true,
      },
      renderTo: {
        value: undefined,
        writable: false,
        configurable: false,
      },
      custom: { value: {}, writable: false, configurable: false },
    });
    return chartPropsToSet
  }, [chartProperties])

  useEffect(() => {
    let updatedData = []
    if (seriesData?.[seriesKey] && seriesData[seriesKey]?.length > 0) {
      updatedData = seriesData?.[seriesKey]?.map(series => {
        return {
          ...series, data: series.data?.map((point) => {
            const { y, ...otherPoints } = point
            return { ...otherPoints, y: y }
          })
        }
      })
    }
    !shouldFetch && setOptions({ ...otherOptions, ...options, chart: { ...propertiesForChart }, series: updatedData })
  }, [shouldFetch, chartOptions, seriesData, loader])

  const handleApiResponse = () => {
    const chartData = data[chartState];
    const chartError = error[chartState];
    let updatedData = []
    if (chartData?.[seriesKey] && chartData[seriesKey]?.length > 0 && !chartError) {
      updatedData = chartData[seriesKey]?.map(series => {
        return {
          ...series, data: series?.data?.map((point) => {
            return { ...point, y: point.yAxis }
          })
        }
      })
    }
    setOptions({
      ...otherOptions,
      chart: { ...propertiesForChart },
      drilldown: {
        series: [],
      }, series: updatedData
    })
  };
  useEffect(() => {
    shouldFetch && handleApiResponse();
  }, [data[chartState], error[chartState], shouldFetch]);
  return (
    <>
      {awaitingResponse[chartState] && <Loader />}
      {error[chartState] ? (<Alert variant="danger" className="mt-16">
        <p className="text-center" style={{ color: "red", margin: 0 }}><span className="icon error-alert me-2"></span>{error[chartState]}</p>
      </Alert>) : null}
      {shouldFetch && !awaitingResponse[chartState] && data[chartState]?.[seriesKey]?.length > 0 && options ? (<HighchartsReact
        highcharts={Highcharts}
        options={options}
        ref={chartRef} />
      ) : null}
      {!shouldFetch && seriesData?.[seriesKey]?.length > 0 && options ? (<HighchartsReact
        highcharts={Highcharts}
        options={{
          ...options,
          title: {
            text: "",
          },
        }}
        ref={chartRef}
      />
      ) : null}
      {!awaitingResponse[chartState] && ((!shouldFetch && (!seriesData?.[seriesKey] || seriesData[seriesKey]?.length === 0)) ||
        (shouldFetch && (!data[chartState]?.[seriesKey] || data[chartState]?.[seriesKey]?.length === 0))) ? (<div className="chart-nodata"><span><NoData /></span></div>) : null}
    </>
  );
}


export default React.memo(LineChart);
